<!-- eslint-disable max-len -->
<template>
  <Menu
    as="div"
    class="relative"
  >
    <MenuButton class="-m-1.5 flex items-center p-1.5">
      <span class="sr-only">Open user menu</span>
      <img
        class="size-8 rounded-full bg-gray-50"
        :src="profileImageUrl"
        alt=""
      >
      <span class="hidden lg:flex lg:items-center">
        <span
          class="ml-4 text-sm/6 font-semibold text-gray-900"
          aria-hidden="true"
        >
          {{ firstName }}
        </span>
        <ChevronDownIcon
          class="ml-2 size-5 text-gray-400"
          aria-hidden="true"
        />
      </span>
    </MenuButton>
    <transition
      enter-active-class="transition ease-out duration-100"
      enter-from-class="transform opacity-0 scale-95"
      enter-to-class="transform opacity-100 scale-100"
      leave-active-class="transition ease-in duration-75"
      leave-from-class="transform opacity-100 scale-100"
      leave-to-class="transform opacity-0 scale-95"
    >
      <MenuItems class="bg-white absolute right-0 z-10 mt-2.5 w-48 origin-top-right rounded-md py-2 ring-1 shadow-lg ring-gray-900/5 focus:outline-hidden">
        <MenuItem v-slot="{ active }">
          <a
            :href="profileHref"
            :class="[active ? 'bg-gray-50 outline-hidden' : '', 'block px-3 py-1 text-sm/6 text-gray-900']"
          >{{ t('sidemenu.navigation.profile.title') }}</a>
        </MenuItem>
        <MenuItem v-slot="{ active }">
          <a
            :href="integrationsHref"
            :class="[active ? 'bg-gray-50 outline-hidden' : '', 'block px-3 py-1 text-sm/6 text-gray-900']"
          >{{ t('plugins.manager.title') }}</a>
        </MenuItem>
        <MenuItem v-slot="{ active }">
          <a
            :href="bioHref"
            :class="[active ? 'bg-gray-50 outline-hidden' : '', 'block px-3 py-1 text-sm/6 text-gray-900']"
          >{{ t('sidemenu.navigation.bio.title') }}</a>
        </MenuItem>
        <MenuItem v-slot="{ active }">
          <a
            :href="affiliateHref"
            :class="[active ? 'bg-gray-50 outline-hidden' : '', 'block px-3 py-1 text-sm/6 text-gray-900']"
          >{{ t('sidemenu.navigation.affiliate-panel.title') }}</a>
        </MenuItem>
        <div class="my-1 border-t border-gray-100" />
        <MenuItem v-slot="{ active }">
          <a
            href="#"
            :class="[active ? 'bg-gray-50 outline-hidden' : '', 'block px-3 py-1 text-sm/6 text-gray-900']"
            @click.prevent="onLogout"
          >{{ t('sidemenu.navigation.signout.title') }}</a>
        </MenuItem>
      </MenuItems>
    </transition>
  </Menu>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';
import {
  Menu, MenuButton, MenuItem, MenuItems,
} from '@headlessui/vue';
import { ChevronDownIcon } from '@heroicons/vue/20/solid';
import useAuthStore from '@/store/auth';
import BlankProfilePicture from '@/assets/images/backgrounds/blank-profile-picture.png';

const router = useRouter();
const { t } = useI18n();
const { session, authDoLogout } = useAuthStore();

const profileImageUrl = computed(() => session?.profileImageUrl || BlankProfilePicture);
const firstName = computed(() => session?.name?.split(' ')[0] || '');
const profileHref = computed(() => router.resolve({ name: 'UserProfileManagerPage' }).href);
const integrationsHref = computed(() => router.resolve({ name: 'PluginsManagerPage' }).href);
const bioHref = computed(() => router.resolve({ name: 'UserBioManagerPage' }).href);
// Affiliate panel used to live only in the left nav of the old dashboard
// layout, which the plugin screens don't render — sellers there had no way
// to reach it. Sits last before the divider so logout stays isolated.
const affiliateHref = computed(() => router.resolve({ name: 'AffiliateDashboardPage' }).href);

const onLogout = async () => {
  try {
    await authDoLogout();
    window.open(router.resolve({ name: 'SessionLoginPage' }).href, '_self');
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error(err);
    // eslint-disable-next-line no-alert
    alert(t('session.logoutError'));
  }
};
</script>
